

























































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { State, Mutation } from 'vuex-class';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { SwNav, SwNavGroup, SwNavItem, SwNavSectionDivider } from '@libs-uuif/shared/sw-nav';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { CoreStoreState, SelectNavItemPayload, SetNavCollapsedPayload } from '@/core';
import { RootStoreState } from '@/store';
import { navService } from '@/app-shared/nav-service';
import { localStorageKeeperService } from '@/shared/auth-service';
@Component({
  components: {
    SwNavGroup,
    SwNavItem,
    SwNavSectionDivider,
    SwNav,
    SwIcon,
  },
})
export default class SwAppNav extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.navCollapsed)
  navCollapsed: CoreStoreState['navCollapsed'];

  @State((state: RootStoreState) => state.CoreStoreModule.selectedTopTabItemId)
  selectedTopTabItemId: CoreStoreState['selectedTopTabItemId'];

  @State((state: RootStoreState) => state.CoreStoreModule.selectedNavItemId)
  selectedNavItemId: CoreStoreState['selectedNavItemId'];

  @Mutation
  selectNavItem: VuexMappedMutation<SelectNavItemPayload>;

  @Mutation
  setNavCollapsed: VuexMappedMutation<SetNavCollapsedPayload>;

  navSize: string = 'default';
  isReportAllow: boolean = false;

  get navData() {
    let navData: any = {};
    const data = navService.tabNavItems.find(item => (item.navId === this.selectedTopTabItemId));
    navData = data ? { ...data.navTree } : {};
    return data ? navData : null;
  }

  get navColor() {
    const data = navService.tabNavItems.find(item => (item.navId === this.selectedTopTabItemId));
    return data ? data.color : 'black';
  }

  /**
   * @desc This Function Handles navbar item selection
   * @param {string} navId - ID of selected navigation bar item
   */
  onSelectNavItem(navId: string) {
    if (this.selectedNavItemId === navId) {
      return;
    }
    const result = navService.getNavNode(navId);
    if (result && result.resNode && result.resNode.route) {
      this.selectNavItem({ navId });
      this.$router.push(result.resNode.route);
    }
  }

  onToggleNavCollapseTrigger() {
    this.setNavCollapsed({ collapse: !this.navCollapsed });
  }
  mounted() {
    const currentUser = JSON.parse(
      localStorageKeeperService.retrieve('currentUser'),
    );
    if (currentUser &&
      currentUser.roles) {
      if (typeof currentUser.roles === 'object') {
        this.isReportAllow = currentUser.roles.length > 0 &&
          currentUser.roles.includes('SPOGREPORTS') || false;
      } else if (typeof currentUser.roles === 'string') {
        this.isReportAllow = currentUser.roles &&
          currentUser.roles.indexOf('SPOGREPORTS') > -1 || false;
      } else {
        this.isReportAllow = false;
      }
    }
  }
}
